import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGrid"><Path fillRule="evenodd" clipRule="evenodd" d="M9.5 7.5H14.5V3H16.5V7.5H21V9.5H16.5V14.5H21V16.5H16.5V21H14.5V16.5H9.5V21H7.5V16.5H3V14.5H7.5V9.5H3V7.5H7.5V3H9.5V7.5ZM9.5 14.5H14.5V9.5H9.5V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGrid;
